// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"efcf87f2","247":"831ea698","284":"d6f0a211","422":"756ee7c0","627":"47552643","768":"0689e717","806":"36ff1176","834":"764ca44f","923":"4c1b21cf","938":"3ac8f029"}[chunkId] + ".chunk.js";
};